import React from 'react';

import { parseAnalysisSummary } from './SyncAnalysisSummary.Functions';
import './SyncAnalysisSummary.Styles.css';

interface IProps {
    summary?: string | null;
}

/**
 * El resumen del análisis, legible.
 *
 * El texto llega corrido, sin saltos de línea, con los hallazgos numerados adentro.
 * Acá se muestra cada hallazgo separado, con sus tres preguntas —dónde, qué pasó y
 * qué hacer— una debajo de la otra. "Qué hacer" va destacado porque es lo único
 * accionable: el resto es contexto.
 *
 * Si el texto no tiene la estructura esperada se muestra tal cual vino, sin
 * maquillarlo: preferible un párrafo honesto que una ficha inventada.
 */
export const SyncAnalysisSummaryComponent: React.FC<IProps> = ({ summary }) => {
    const parsed = parseAnalysisSummary(summary);

    if (!parsed.raw) return null;

    if (!parsed.isStructured) {
        return <p className="sas__raw">{parsed.raw}</p>;
    }

    return (
        <div className="sas">
            {parsed.intro && <p className="sas__intro">{parsed.intro}</p>}

            <ol className="sas__list">
                {parsed.findings.map((finding) => (
                    <li key={finding.index} className="sas__finding">
                        <div className="sas__finding-header">
                            <span className="sas__number" aria-hidden="true">{finding.index}</span>
                            <span className="sas__finding-title">{finding.title}</span>
                        </div>

                        {finding.where && (
                            <div className="sas__field">
                                <span className="sas__label">Dónde</span>
                                <span className="sas__value">{finding.where}</span>
                            </div>
                        )}

                        {finding.what && (
                            <div className="sas__field">
                                <span className="sas__label">Qué pasó</span>
                                <span className="sas__value">{finding.what}</span>
                            </div>
                        )}

                        {finding.action && (
                            <div className="sas__field sas__field--action">
                                <span className="sas__label">Qué hacer</span>
                                <span className="sas__value">{finding.action}</span>
                            </div>
                        )}
                    </li>
                ))}
            </ol>

            {parsed.outro && <p className="sas__outro">{parsed.outro}</p>}
        </div>
    );
};

export default SyncAnalysisSummaryComponent;
